// src/auth/PermissionsProvider.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { meAPI } from "../services/api"; // your axios instance with auth header
import { buildPermSet, canDo, canAny, canAll } from "./rbac";

const Ctx = createContext({
  ready: false,
  perms: new Set(),
  can: () => false,
  any: () => false,
  all: () => false,
});

export const PermissionsProvider = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [permSet, setPermSet] = useState(new Set());

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Backend should return: { permissions: [{resource,action}, ...], role?: 'admin' }
        // const { data } = await api.get("/me/permissions");
        const data = await meAPI.getPermissions();

        console.log("Permission Data :::; ", data);
        
        let perms = data?.permissions || [];

        // If admin, grant "all:all" client-side too (optional; server already authoritative)
        if (String(data?.role || "").toLowerCase() === "super admin") {
          perms = [{ resource: "all", action: "all" }, ...perms];
        }
        if (mounted) setPermSet(buildPermSet(perms));
      } catch (e) {
        if (mounted) setPermSet(new Set()); // safest default: no perms
      } finally {
        if (mounted) setReady(true);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const value = useMemo(() => ({
    ready,
    perms: permSet,
    can: (resource, action) => canDo(permSet, resource, action),
    any: (list) => canAny(permSet, list),
    all: (list) => canAll(permSet, list),
  }), [ready, permSet]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const usePerms = () => useContext(Ctx);
